module.exports = __webpack_public_path__ + "img/xbzp2.feb630eb.png";